import { GameCommunicationBetSender as CoreBetSender, GameCommunicationSenderType } from '@pp/core';

import type { GameStore } from '../../../store/GameStore';

export class GameInstantBetsSender extends CoreBetSender {
  send(_: never, store: GameStore, sender: GameCommunicationSenderType): void {
    const computedBetsArr: { betId: number; value: number }[] = [];
    const state = store.getState();
    const gameChannel = state.gameState.gameChannel;
    const gameId = state.gameState.gameId;
    const gameName = state.config.session?.gametype;
    const computedBets = state.bets.betStack[state.bets.betStack.length - 1];
    if (computedBets) {
      Object.keys(computedBets.betSpots)
        .map(Number)
        .forEach((betId) => {
          const betValue = computedBets?.betSpots[betId]?.value;
          if (betValue) {
            computedBetsArr.push({ betId, value: betValue });
          }
        });
    }

    let betTags = '';
    computedBetsArr.forEach((bet) => {
      betTags += `<bet amt="${bet.value}" bc="${bet.betId}" ck="${Date.now()}" />`;
    });
    let message = '';
    message += `<command channel="${gameChannel}">`;
    message += `<lpbet gm="${gameName}" gId="${gameId}" uId="${state?.gameState?.userInfo
      ?.userId}" ck="${Date.now()}">`;
    message += betTags;
    message += `</lpbet> `;
    message += '</command>';
    sender?.(message);
  }
}
